import { render, staticRenderFns } from "./CheeseVideoCard.vue?vue&type=template&id=422bbd70&scoped=true&"
import script from "./CheeseVideoCard.vue?vue&type=script&lang=js&"
export * from "./CheeseVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./CheeseVideoCard.vue?vue&type=style&index=0&id=422bbd70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422bbd70",
  null
  
)

export default component.exports